module.exports = __webpack_public_path__ + "static/media/karate-kids.4d927374.mov";